module.exports = __webpack_public_path__ + "img/cssc_logo.41b4b74c.png";